let en = {
  componentModule: "Component List",
  componentMenu: "Component Menu",
  componentCreationReview: "Comp. Creation/Review",
  paramsManagement: "Parameter",
  manufacturerManagement: "Manufacturer",
  encapsulationTypeManagement: "Package Type",
  componentMaterial: "Material configuration",
  componentParameters: "Component Parameters",
  systemSettings: "System Settings",
  permissionManagement: "Permission Management",
  accountManagement: "Account Management",
  operationLog: "Operation Log",
  databaseManagement: "Database Management",
  version: "Version",
  systemGuidelines: "System Guidelines",
  login: "Login",
  zhmmdl: "Account password login",
  xgsjk: "Modify the database",
  enterUsername: "Please enter the username",
  enterPass: "Please enter tha password",
  remPass: "Remember password",
  forgotPass: "Forgot password",
  xgzhmm: "Modify account or password",
  srjmm: "Please enter old password",
  srxmm: "Please enter a new password",
  qrxmm: "Confirm new password",
  qd: "Sure",
  cancel: "Cancel",
  sslxqh: "Search type switching",
  jqss: "Accurate search",
  mhss: "Fuzzy search",
  zzsmc: "Manufacturer name",
  enterZzs: "Please enter the manufacturer name(EN)",
  zzslh: "Manufacturer Part Number",
  enterzzslh: "Please enter the manufacturer part number",
  zzsfzmc: "Manufacturer Package Name",
  enterzzsfzmc: "Please enter the manufacturer package name",
  cjz: "creator",
  entercjz: "Please enter the creator name",
  createTime: "Create Time",
  startTime: "Start Time",
  endTime: "End Time",
  reset: "Reset",
  search: "Search",
  searchSet: "Search Settings",
  plsc: "Batch Delete",
  dr: "Import",
  dc: "Export",
  zdsz: "Field set",
  xh: "No.",
  fzlx: "Package Type",
  fzzlx: "Package Subtype",
  length: "Length",
  width: "Width",
  gong: "Total",
  tiao: "items",
  everyPage: "Per page",
  go: "Go",
  sszdpz: "Search field configuration",
  pn: "PN code",
  yjxx: "Component information",
  yjc: "Component length",
  yjk: "Component width",
  yjg: "Component height",
  yjmx: "Pin model",
  yjsl: "Number of pins",
  yjjj: "Pin pitch",
  csmc: "Parameter",
  csm: "Parameter",
  csz: "Parameter values",
  cszfw: "Parameter value range",
  shz: "Reviewer",
  shsj: "Review time",
  drgxyjxx: "Import and update component information",
  rz: "Log",
  xzxydrdsjk: "Select the database to import",
  cslj: "Test connection",
  yshyssffg: "Has the audited component been covered",
  yes: "Yes",
  no: "No",
  dkbglj: "Open report path",
  dcyjxx: "Export component information",
  xzxydcdsjk: "Select the database to export",
  zhmc: "Account name",
  enterZhmc: "Please enter the account name",
  zhqx: "Account permissions",
  xjzh: "Create new Account",
  bjzh: "Edit account",
  zt: "State",
  fpqx: "Assign permissions",
  cz: "Operate",
  bj: "Edit",
  sc: "Delete",
  yjbjq: "Component Editor",
  xjandbjzh: "Create&Edit Account",
  zhmm: "Account password",
  enterZhmm: "Please enter your account password",
  qrmm: "Confirm password",
  enterQrmm: "Please enter your account password again",
  sfqy: "Enable or not",
  exitVal: "Log out",
  all: "All",
  jscd: "Roles list",
  cjjs: "Create role",
  bjjs: "Edit Role",
  qsrjsm: "Please enter the role name",
  qsr: "Please enter",
  jsm: "Role name",
  qxsz: "Permission settings",
  qrsctc: "Confirm to delete",
  qrscjs:
    "Are you sure you want to delete it? It cannot be restored after deletion!",
  bm: "Department",
  qsrbm: "Please enter the department",
  qxzfpqx: "Please choose to assign permissions",
  qxzsfqy: "Please choose whether to enable or not",
  mmbyz: "Two passwords are inconsistent",
  isSubmiting: "Submitting",
  fzlxmc: "Encapsulation type name",
  enterfzlxmc: "Please enter the encapsulation type name",
  fzzlxbz: "Encapsulation Subtype Remarks",
  enterfzzlxbz: "Please enter the encapsulation subtype remark",
  fzlxbz: "Packaging Type Remarks",
  enterfzlxbz: "Please enter the encapsulation type remark",
  fzzlxmc: "Encapsulation subtype name",
  enterfzzlxmc: "Please enter the encapsulation subtype name",
  pleaseEnter: "Please enter",
  add: "Create",
  bz: "Remark",
  xzfzlx: "Add encapsulation type",
  bjfzlx: "Edit encapsulation type",
  fzlxxx: "Encapsulation type information",
  qsrzzsmc: "Please enter the Manufacturer name",
  hbzzs: "Merge manufacturers",
  zzsmc: "Manufacturer name",
  bdyjsl: "Bound comp. qty.",
  gfwz: "Official website",
  yj: "Email",
  shzt: "Review status",
  sh: "Review",
  dsh: "Pending approval",
  ysh: "Reviewed",
  zzsbmxs: "Manufacturer Alias Listing",
  zzsbm: "Manufacturer Alias",
  zzsxx: "Manufacturer information",
  zzswz: "Manufacturer website",
  zzsyj: "Manufacturer email",
  sftgzzs: "Has the manufacturer been approved for review?",
  drzzsxx: "Import manufacturer information",
  mbxz: "Template Download",
  xzzzsdrmb: "Download Manufacturer Import Template",
  drxx: "Import information",
  drts: "Click to select CSV file, or drag and drop to upload here, only supports. csv format files, not exceeding 50MB",
  zzshb: "Manufacturer merger",
  hb: "Merge",
  jiang: "",
  hbjzzs: "Merge To manufacturers",
  qsrzzsmcjxss: "Please enter the manufacturer name to search",
  hbfs: "Merge method",
  tszyzzs: "Simultaneously transferring manufacturers",
  jjxqjzy: "Only perform device transfer",
  jxhb: "Merge",
  hbjxzts: "Merge in progress, please do not shut down the system",
  fzzlxxx: "Encapsulate subtype information",
  dlrz: "Login Log",
  czrz: "Operation Log",
  hyzh: "Member account",
  qsrzhcx: "Please enter your account to search",
  dlsj: "Login time",
  dlzh: "Login Account",
  qx: "Permission",
  rznr: "Log content",
  czsj: "Operating time",
  czlx: "Operation type",
  zh: "Account",
  plscqr:
    "Please confirm whether to delete the selected encapsulation type. Once deleted, the data cannot be recovered",
  plscqr2:
    "Please confirm whether to delete the selected manufacturer. Once deleted, the data cannot be recovered",

  plscqr3:
    "Please confirm whether to delete the selected database. Once deleted, the data cannot be recovered",
  xgmm: "Change Password",
  srjmm: "Enter old password",
  srxmm: "Enter new password",
  qrxmm: "Confirm new password",
  ts: "Notice",
  xgmmcg: "Password changed successfully!",
  zbmhhss: "Main alias mixed search",
  qxz: "Please select",
  xzzzs: "Add manufacturer",
  bjzzs: "Edit manufacturer",
  qsrzzswz: "Please enter the manufacturer website",
  qsrzzsyj: "Please enter the manufacturer email",
  pic: "2D/3D Switching",
  kssj: "Start Time",
  jssj: "End Time",
  jcxx: "Basic information",
  bjxx: "Edit information",
  dqxzzd: "Current selection field",
  qsrzzsbmen: "Please enter the Manufacturer Alias(EN)",
  qsrzzsbmcn: "Please enter the Manufacturer Alias(CN)",
  cx: "cancellation",
  pz: "approved‌",
  gao: "Height",
  bjz: "Editor",
  bjsj: "Edit time",
  syzd: "All fields",
  zdpzts:
    "The component parameters added by the user will be displayed here by default",
  enterPn: "Please enter PN code",
  dryj: "Import components",
  yxyjdc: "Selected components exported",
  cjsjdc: "Create time export",
  cjry: "Creator",
  xjsjk: "Create database",
  xjyqj: "Create new component",
  dqsjklb: "Database list",

  dlfs: "Login method",
  qds: "drive",
  server: "server",
  port: "port",
  username: "username",
  psw: "password",
  database: "database",
  parameter: "parameter",
  confirm: "confirm",
  edit: "edit",
  testlink: "test link",

  sjkmc: "Database name",
  sjkdz: "Database ip",
  sjkdk: "Database port",
  sjkzt: "type",
  xz: "select",

  yzsb: "Validation failed",
  yztg: "Verified",
  dyz: "To be verified",
  qxzdlsjk: "Please select the database",
  xzsjkbtn: "Select database",
  dqxz: "Current selection",
  testErrMsg: "Please create database, and try again",
  qxzsjk: "Please select a database",
  shtg: "Review Approved",
  zm: "Main",
  bm: "Alias",
  wjqddc: 'Export file list',
  qxfpqx: 'Please allocate permissions first',
  loading: 'Loading...',
  view: "view",
  sjkbf: "Current database backup",
  gd: 'More',
  fz: 'Copy',
  cxMPN: 'Link new MPN',
  szclys: 'Set materials & colors',
  switchtext: 'Enabling component parameter settings allows for setting component parameters when creating components',
  xjyjcs: 'Add new component parameters',
  bjyjcs: 'Edit component parameters',
  cslx: 'Comp. Param type',
  qxzcslx: 'Please select the type of component parameter',
  yjcsm: 'Comp. Params name',
  enterYjcsm: 'Please enter the parameter name of the component',
  yjcsdw: 'Comp. Params unit',
  enterYjcsdw: 'Please enter the unit of component parameters',
  lx: 'Type',
  dw: 'Unit',
  czbm: 'Material code',
  czmc: 'Material name',
  enterCzbm: 'Please enter the material code',
  enterCzmc: 'Please enter the material name',
  elementConfiguration: 'Element configuration',
  yuansu: 'Element',
  tslx: 'Special type',
  yanse: 'Colour',
  yjcz: 'Component operation',
  pleaseEnter2: '',
  qxz2: '',
  startTime2: "",
  endTime2: "",
  xzys: 'Create new elements',
  ysmc: 'Element Name',
  ysbh: 'Element Code.',
  enterYsbh: 'Please select the element Code.',
  enterYsmc: 'Please enter the element name',
  bjys: 'Edit elements',
  tslxbh: 'Special Type Code.',
  enterTslxbh: 'Please select the special Type Code.',
  tslxmc: 'Special Type Name',
  enterTslxmc: 'Please enter the name of the special type',
  yanse: 'Color',
  yansebh: 'Color Code.',
  yansemc: 'Color Name',
  enterYansebh: 'Please select the color Code.',
  enterYansemc: 'Please enter the color Name',
  xztslx: 'Create new special types',
  bjtslx: 'Edit special types',
  xzyanse: 'Create new colors',
  bjyanse: 'Edit colors',
  zdyyjcskg: 'Custom component parameter switch',
  ycjyjcs: 'Component parameters have been created',
  ysczzh: 'Element material combination',
  czbm: 'Material code',
  czmc: 'Material name',
  xzyjcz: 'Create component material',
  bjyjcz: 'Edit component material',
  czlx: 'Material type',
  mc: 'Name',
  hj: 'Alloy',
  tc: 'Coating',
  yssl: 'Elem. Count',
  xzyssl: 'Please select the number of elements',
  dyzys: 'The first element',
  derzys: 'The second element',
  qxzys: 'Please select an element',
  xzxsys: 'Select color',
  baocun: 'Save',
  qxzyanse: 'Please choose a color',
  qxzlx: 'Please select type',
  assignMaterials: 'Assign materials',
  wsyczlb: 'Unused Material List',
  ysyczlb: 'Used Material List',
  yzbt: 'Used as ontology',
  yzyj: 'Used as a pin',
  tszy: 'Simultaneous action',
  yc: 'Remove',
  czlb: 'Material List',
  btczlb: 'List of Body Materials',
  yjczlb: 'Pin Material List',
  bh: 'Code',
  gx: 'Update',
  ysczzhycz: 'This element material combination number already exists',
  xinjian: 'Create',
  zhantie: 'Paste',
  szczhys: 'Set materials & colors',
  bjmpnhmfg: 'Edit MPN & MFG',
  sjklx: 'Database type',
  jzzsmc: 'Old manufacturer name',
  xzzsmc: 'New manufacturer name',
  jzzslh: 'Old manufacturer part number',
  xzzslh: 'New manufacturer part number',
  enterXzzsmc: 'Please select a new manufacturer name',
  enterXzzslh: 'Please enter a new manufacturer part number',
  xuanzhuan: 'Rotate',
  sjzs: 'Data display',
  liebiao: 'List',
  cssj: 'Param data',
  benti: 'Body',
  xingzhuang: 'Shape',
  ysfx: 'Ext. direction',
  yinjiao: 'Pin',
  yjmc: 'Pin Name',
  jxyj: 'Polarity element',
  weizhi: 'Position',
  zjz: 'Med.',
  zpc: 'Pos. Dev.',
  fpc: 'Neg. Dev.',
  zdz: 'Max',
  zxz: 'Min',
  jztx: 'Load Graphics',
  clgj: 'Measure Tool',
  jzdt: 'Load basemap',
  jzpdf: 'Load PDF',
  gbpdf: 'Close PDF',
  yjshlc: 'Component review process',
  bzms: 'Label Mode',
  zzms: 'Allowance mode',
  psyj: 'Review Notes',
  tuichu: 'Quit',
  syg: 'Previous',
  xyg: 'Next',
  pldrsn: 'Batch import PN',
  xzsndrmb: 'Download PN Import Template',
  drsb: 'Import exception',
  drsbqd: 'importFailedList',
  xzcwbg: 'Download Error Report',
  xzbg: 'Download Report',
  gaodu: 'Height',
  step1: 'Basic Information Confirmation',
  tip1: 'Base image and PDF manual have been uploaded',
  tip2: 'Manufacturer name, manufacturer part number, and manufacturer package name are consistent with the manual',
  tip3: 'Package type and sub-type are selected correctly',
  tip4: 'Body material, pin material, and device parameters are consistent with the manual',
  step2: 'Polarity Information Confirmation',
  tip5: 'Polarity component is selected correctly',
  tip6: 'Polarity position is placed correctly',
  step3: 'Body Information Confirmation',
  tip7: 'Body shape and standoff height are correct',
  tip8: 'Body dimensions are correct',
  step4: 'Pin Information Confirmation',
  tip9: 'Pin model and shape are correct',
  tip10: 'Pin position and orientation are correct',
  step5: 'Confirm whether other parameters are correct',
  tip11: 'Pin names are correct',
  kai: 'Open',
  guan: 'Close',
  enterBz: 'Please enter the remark',
  plppyj: 'Batch Match Comp',
  xzdrmb: 'Download Import Template',
  ppyqjsfzkz: 'Check whether the matching components exist in the library',
  ppcg: 'Match successful',
  ppsb: 'Matching failed',
  ppl: 'Matching Rate',
  ppsbqd: 'matchFailureList',
  ppyc: 'Match exception',
  drcg: 'Import success',
  drsbai: 'Import failed',
  kshbzzs: 'Start the merger of manufacturers',
  dhbyjsl: 'Pending merge count',
  hbyc: 'Merge failed',
  hbcg: 'Merge successful',
  cwrz: 'Error log',
  qxzzzs: 'Please select the manufacturer name',
  zzslhlb: 'MPN list',
  lhtpf: 'Encapsulated Graphics',
  gllh: 'Link MPN',
  czcg: 'Success',
  qxzydcdx: 'Please select the components to export',
  zdzxzms: 'Extremum Mode',
  hbcgyjsl: 'Merged success count',
  dcz: 'Exporting...',
  ksjxdc: 'Start exporting...',
  dcyjsl: 'Export Count',
  dcwc: 'Export completed',
  dcsb: 'Export failed',
  ksjxdr: 'Importing...',
  drwc: 'Import completed',
  drsbai: 'Import failed',
  page: 'Page',
  clgl: 'Material Management',
  bccg: 'Successfully saved',
  shtgl: 'Approved',
  shwtgl: 'Review failed',
  dcmy: 'No matching exported content',
  juxing: 'Rectangle',
  yuanxing: 'Circle',
  duobianxing: 'Polygon',
  zhijing: 'Diameter',
  plexe: 'BRPT&PM',
  plsxQxz: 'Please select components',
  plsxfzlxyjmx: 'Batch Refresh Package Type & Pin Model',
  dccg: 'Export successful',
  hengxiang: 'horizontal',
  zongxiang: 'longitudinal',
  sflx: 'Boolean type',
  ryzfclx: 'Any string',
  rqlx: 'Date type',
  zslx: 'Integer type',
  zdylx: 'Custom type',
  quanxuan: 'Select All',
  enterZzslhlb: 'Please enter the MPN list',
  jbxx: 'Basic information',
  zhi: 'Value',
  tbyjcs: 'Synced params',
  refresh: 'Refresh',
  bzsc: 'Help manual',
  zzs: ' Manufacturer',
  yjcs: 'Component Parameters',
  btcl: 'Body Material',
  yjcl: 'Pin Material',
  yqwq: 'Lead Free/Tin Lead',
  ESDdj: 'ESD Level',
  zl: 'Weight',
  smdj: 'Humidity Level',
  bzjd: 'Package Angle',
  bzpitch: 'Package Pitch',
  bzfs: 'Package Type',
  gl: 'Power',
  RoHShbyq: 'RoHS Requirements',
  wd: 'Temperature',
  xzcs: 'Add new parameter',
  dcyjcs: 'Export component parameters',
  pldrcs: 'Batch Import Parameters',
  wx: 'Appearance',
  yinj: 'Pin',
  cs: 'Parameter',
  cjxz: 'Create/Review',
  fg: 'Overwrite',
  zj: 'Append',
  overwriteDialogMessage: 'Duplicate parameters detected. Confirm overwrite?',
  bjyqj: 'Edit Component',
  drjg: 'Import Results',
  enterYjzdycs: 'Please enter custom component parameters',
  yjzdycs: 'Custom component parameters',
  qxzsj: 'Please select a time',
  tsgd: 'Lifting height',
  cd: 'Length',
  kd: 'Width',
  jx: 'Polarity',
  qxcl: 'Clear Measure',
  spwtgbsp: 'Components that have not passed the review are not allowed to be revoked or approved',
  fzzzs: 'Copy manufacturer',
  dycg: 'Call successful',
  fzyj: 'Copy components'
};

export default en;
